import styled from 'styled-components';

import { size } from '../../layout/helpers';

const iconSize = '1rem';
const selectPadding = size(2);

export const Wrapper = styled.div.withConfig({ componentId: 'sc-1yh8lcv-0' })`
    position: relative;
    background-color: var(--c-bg-main);
    border: 1px solid var(--c-border-main);
    box-shadow: ${(props) => props.theme.boxShadow.inset};
    border-radius: ${(props) => props.theme.size.borderRadius};

    :focus-within {
        border-color: var(--c-input-border-focus);
    }
`;

export const Select = styled.select.withConfig({ componentId: 'sc-1yh8lcv-1' })`
    position: relative;
    display: block;
    width: 100%;
    height: ${(props) => props.theme.size.inputHeight};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    text-indent: 0.01px;
    border: 0;
    padding: 0 ${selectPadding};
    padding-right: calc(${iconSize} + ${selectPadding});
    background-color: transparent;
    color: var(--c-text-main);
    font-family: var(--font-family);
    font-weight: var(--font-weight-light);
    border-radius: 0;
    font-size: var(--font-size-input);
    cursor: pointer;
    z-index: 1;

    :focus {
        outline: none;
    }

    ::-ms-expand {
        display: none;
    }

    ::-moz-focus-inner {
        border: 0;
    }

    &[disabled] {
        opacity: 0.37;
        cursor: not-allowed;
    }
`;

export const Option = styled.option.withConfig({ componentId: 'sc-1yh8lcv-2' })`
    color: var(--c-text-main);
`;

export const Icon = styled.div.withConfig({ componentId: 'sc-1yh8lcv-3' })`
    position: absolute;
    top: 50%;
    right: ${selectPadding};
    transform: translateY(-50%);
    font-size: ${iconSize};
    z-index: 1;
    pointer-events: none;
`;
